import { ANSWERED_COUNTER_STYLE } from './projectionScale';

// WIP-011 (design §2.2, §2.4) — the OPEN state's live count: the one thing
// that DOES update while voting is open ("updating as votes arrive" applies
// to this, never to bars — design §1, C2). `expected` is the active roster
// count (design §2.3); when it is unavailable the counter degrades to
// "n answered" rather than a broken "n of null".
export default function ProjectionCounter({ count, expected }: { count: number; expected: number | null }) {
  const pct = expected && expected > 0 ? Math.max(0, Math.min(100, (count / expected) * 100)) : null;
  return (
    <div className="flex w-full max-w-2xl flex-col items-center">
      <div style={ANSWERED_COUNTER_STYLE} className="tabular-nums text-ws-ink">
        {expected != null ? `${count} of ${expected}` : `${count} answered`}
      </div>
      {pct != null && (
        <div className="mt-[1.5vh] h-[1.5vh] w-full overflow-hidden rounded-full bg-ws-surface-2">
          <div className="ws-progress-fill h-full rounded-full bg-ws-accent" style={{ width: `${pct}%` }} />
        </div>
      )}
    </div>
  );
}
